import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import dataLayer from '@rover/globals/dataLayer';
import Rover from '@rover/globals/Rover';

export default Backbone.View.extend({
  SERVICE_TYPE_OVERNIGHT_BOARDING: 'overnight-boarding',
  SERVICE_TYPE_OVERNIGHT_TRAVELING: 'overnight-traveling',

  initialize(options) {
    this.searchResults = options.searchResults;
    this.listenTo(this.searchResults, 'change', _.bind(this.onSearchResultsChanged, this));
    Rover.pubSub.on('search:start', _.bind(this.trackSearchEvent, this));
  },

  getLocationType(location) {
    /* Parses the type of location from the location search paramater
         * and returns the correct event type.
         *
         * Zip code searches return 'zip-code'
         * City searches return 'city'
         * Other searches return 'address'
         */
    const zipRegex = /\d{5}/;
    if (!location) {
      return 'city';
    }

    if (/\d/.test(location.replace(zipRegex, '')) === true) {
      return 'address';
    }

    if (zipRegex.test(location) === true) {
      return 'zip-code';
    }

    return 'city';
  },

  trackSearchEvent(params) {
    // These should be sent for every search performed
    // (i.e. switching service, changing filters, adding dates, etc)
    const locationType = this.getLocationType(params.location);

    dataLayer.push({ event: 'perform-search' });

    dataLayer.push({
      event: `${locationType}-search`,
      search_location: params.location,
      search_centerlat: params.centerlat,
      search_centerlng: params.centerlng,
      search_dog_preferences: params.dog_preferences,
      search_maxlat: params.maxlat,
      search_maxlng: params.maxlng,
      search_minprice: params.minprice,
      search_maxprice: params.maxprice,
      search_minlat: params.minlat,
      search_minlng: params.minlng,
      search_page: params.page,
      search_service_type: params.service_type,
      search_zoomlevel: params.zoomlevel,
      search_start_date: params.start_date,
      search_end_date: params.end_date,
      service_type: params.service_type,
    });
  },

  trackSearchPageVisit(params) {
    // This should be sent only on the first visit to the search page for
    // each location.
    // This does not get called by switching services, changing filters, etc
    // for the same zipcode or location
    this.sendSearchEventNotification('search-search-page-visit', params);
  },

  sendSearchEventNotification(eventName, query) {
    const dropOff = query.start_date;
    const pickUp = query.end_date;
    const service = query.service_type;
    const address = query.location;

    const notificationData = {
      event: eventName,
      zipCode: address || null,
      serviceType: service || null,
      dogSize: this.getDogSizes(query),
      dropOffDate: dropOff || null,
      pickUpDate: pickUp || null,
    };
    dataLayer.push(notificationData);
  },

  getDogSizes(params) {
    const allDogSizes = ['small_dogs', 'medium_dogs', 'large_dogs', 'giant_dogs'];
    const dogSizes = [];
    allDogSizes.forEach(size => {
      if (params[size]) {
        dogSizes.push(size);
      }
    });
    return dogSizes.length > 0 ? dogSizes.join(', ') : '';
  },

  onSearchResultsChanged() {
    const callouts = this.searchResults.get('callouts');
    if (!callouts) {
      return;
    }
    callouts.forEach(callout => {
      if (callout.slug === 'hybrid-dog-walking-callout') {
        dataLayer.push({
          event: 'quick-match-search-results-display',
          marketName: callout.data.market,
        });
      }
    });
  },

  onInitialLoad(query) {
    const queryJson = query.toJSON();
    this.trackSearchEvent(queryJson);
    this.trackSearchPageVisit(queryJson);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/event_tracker.js